module.exports = __webpack_public_path__ + "c566657733c225ab3cc0cdfa5076b396.svg";